import { Col, DatePicker, Form, Row, Select} from "antd";
import React from "react";

const {Option} = Select;

export default (props)=>{
    let {_this}=props;
    const onChangeStartDate=(key,date)=>{
        _this.setState({
            startDate:date
        });
        console.log("onChangeStartDate -----> ",date)
    }
    const onChangeEndDate=(key,date)=>{
        _this.setState({
            endDate:date
        });
        console.log("onChangeEndDate -----> ",date)
    }
    return(
        <Row gutter={16}>
            <Col span={11}>
                <Form.Item
                    name="startDate"
                    label="Start Date"
                    rules={[{ required: true, message: 'Please choose the start date' }]}
                >
                    <DatePicker onChange={onChangeStartDate} style={{minWidth:"100%"}}/>
                </Form.Item>
            </Col>
            <Col span={11}>
                <Form.Item
                    name="endDate"
                    label="End Date"
                    rules={[{ required: true, message: 'Please choose the end date' }]}
                >
                    <DatePicker onChange={onChangeEndDate} style={{minWidth:"100%"}}/>
                </Form.Item>
            </Col>
        </Row>
    )
}
